import React, { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X, Phone } from "lucide-react";
import { SUPPORT_PHONE, SUPPORT_PHONE_TEL } from "@/lib/format";

const links = [
  { to: "/", label: "Home" },
  { to: "/properties", label: "Homes" },
  { to: "/about", label: "About" },
  { to: "/contact", label: "Contact" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-40 bg-[#FAF9F6]/90 backdrop-blur-md border-b-2 border-black" data-testid="navbar">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-3 flex items-center justify-between">
        <Link to="/" data-testid="navbar-logo" className="flex items-center gap-3">
          <img src="/thc-logo.png" alt="The Homestay Company Logo" loading="eager" fetchPriority="high" decoding="async" className="h-10 w-10 object-contain" />
          <div className="leading-none">
            <div className="font-display font-extrabold text-lg tracking-tight">The Homestay Company</div>
          </div>
        </Link>

        <nav className="hidden md:flex items-center gap-1">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={`nav-${l.label.toLowerCase()}`}
              className={({ isActive }) =>
                `font-display font-semibold px-4 py-2 rounded-full transition-all ${
                  isActive ? "bg-black text-white" : "text-black hover:bg-[#FFD166]"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-3">
          <a href={`tel:${SUPPORT_PHONE_TEL}`} data-testid="navbar-call-cta" className="hidden lg:inline-flex items-center gap-2 px-3 py-2 border-2 border-black rounded-full font-display font-bold text-sm hover:bg-[#20E3B2] transition-colors">
            <Phone size={14}/> {SUPPORT_PHONE}
          </a>
          <Link to="/contact" data-testid="navbar-book-cta" className="brutal-btn brutal-btn-yellow">Book a Visit</Link>
        </div>

        <button data-testid="navbar-mobile-toggle" className="md:hidden p-2 border-2 border-black rounded-lg" onClick={() => setOpen(!open)}>
          {open ? <X size={20}/> : <Menu size={20}/>}
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t-2 border-black bg-white px-4 py-3 space-y-2" data-testid="navbar-mobile-menu">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              onClick={() => setOpen(false)}
              className="block font-display font-semibold px-4 py-3 border-2 border-black rounded-xl"
            >
              {l.label}
            </NavLink>
          ))}
          <Link to="/contact" onClick={() => setOpen(false)} className="brutal-btn brutal-btn-yellow w-full">Book a Visit</Link>
        </div>
      )}
    </header>
  );
}
